import React, { createContext } from "react";
import { ActionName } from "types/common";

type ModalContextType = {
  modalType: any;
  setModalType: any;
  showProjects: boolean;
  setShowProjects: React.Dispatch<React.SetStateAction<boolean>>;
  showKeyGuide: boolean;
  setShowKeyGuide: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ModalContext = createContext<ModalContextType>({
  modalType: '',
  setModalType: () => { },
  showProjects: false,
  setShowProjects: () => { },
  showKeyGuide: false,
  setShowKeyGuide: () => { },
});

const ModalProvider = ({ children }: any) => {
  const [modalType, setModalType] = React.useState<ActionName | ''>('');
  const [showProjects, setShowProjects] = React.useState<boolean>(false);
  const [showKeyGuide, setShowKeyGuide] = React.useState<boolean>(false);

  return (
    <ModalContext.Provider value={{ modalType, setModalType, showProjects, setShowProjects, showKeyGuide, setShowKeyGuide }}>
      {children}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
